import { styled, ToggleButton } from '@mui/material';

interface StyledToggleButtonProps {
  isFirst: boolean;
  isLast: boolean;
  isSelected: boolean;
  isVertical?: boolean;
}

const getBorderRadius = (isFirst: boolean, isLast: boolean, isVertical?: boolean) => {
  if (isVertical) {
    // Vertical layout: first has top rounded corners, last has bottom rounded corners
    if (isFirst) return '20px 20px 0 0';
    if (isLast) return '0 0 20px 20px';
    return 0;
  } else {
    // Horizontal layout: first has left rounded corners, last has right rounded corners
    if (isFirst) return '40px 0 0 40px';
    if (isLast) return '0 40px 40px 0';
    return 0;
  }
};

const getSelectedStyles = (theme: any) => ({
  backgroundColor: theme.palette.rose[50],
  border: `2px solid ${theme.palette.rose[500]}`,
  color: theme.palette.rose[500],
});

const getUnselectedStyles = (theme: any) => ({
  backgroundColor: '#fff',
  border: `1px solid ${theme.palette.grey[600]}`,
  color: theme.palette.grey[800],
});

export const StyledToggleButton = styled(ToggleButton, {
  shouldForwardProp: (prop) => !['isFirst', 'isLast', 'isSelected', 'isVertical'].includes(prop as string),
})<StyledToggleButtonProps>(({ theme, isFirst, isLast, isSelected, isVertical }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: isVertical ? 'center' : 'flex-start',
  gap: theme.spacing(2),
  height: theme.spacing(11),
  padding: `${theme.spacing(3)} ${theme.spacing(4)}`,
  borderRadius: getBorderRadius(isFirst, isLast, isVertical),

  cursor: 'pointer',
  textTransform: 'none',
  fontSize: theme.typography.body2.fontSize,
  fontWeight: 400,

  ...(isSelected ? getSelectedStyles(theme) : getUnselectedStyles(theme)),

  '&.Mui-selected': getSelectedStyles(theme),
  '&:not(.Mui-selected)': getUnselectedStyles(theme),
  '&:hover': {
    backgroundColor: theme.palette.rose[50],
  },
  '&.Mui-selected:hover': {
    backgroundColor: theme.palette.primary.light,
  },
}));
